import {mapActions} from "vuex";

export default {
    methods: {
        ...mapActions(['ACTIVE_ALERT']),
        alertSuccess(text) {
            this.ACTIVE_ALERT({
                state: true,
                type: 'success',
                text: text
            })
        },
        alertError(text) {
            this.ACTIVE_ALERT({
                state: true,
                type: 'error',
                text: text
            })
        },
        alertWarning(text) {
            this.ACTIVE_ALERT({
                state: true,
                type: 'warning',
                text: text
            })
        },


        returnErrorText(error, title = 'Произошла ошибка!') {
            let text = error.response.data.message;
            switch (text) {
                case 'ERR_BALANCE_FUNDS_INFLUENCE':
                    return 'Недостаточно средств!'
                default:
                    return title
            }
        }
    }
}